<template>
  <div>
    <Landing :is-o-auth="true" />
  </div>
</template>

<script>
import Landing from '@/views/Landing.vue';
import { oAuthApi } from '@/services/apis';
import { mapActions } from 'vuex';

export default {
  name: 'OAuth',
  components: {
    Landing
  },
  computed: {
    getQuery() {
      return this.$route.query;
    },
    getOAuthSession() {
      return JSON.parse(sessionStorage.getItem('oAuth'));
    },
    hasOAuth() {
      return Boolean(this.getOAuthSession?.redirectURI);
    },
    isNotSameState() {
      if (this.getOAuthSession?.state && this.getQuery?.state) {
        return this.getOAuthSession?.state !== this.getQuery?.state;
      }
      return false;
    }
  },
  async mounted() {
    if (!this.hasOAuth || this.isNotSameState) {
      await this.fetchAuthorize();
    }
    this.clearQuery();
  },
  methods: {
    ...mapActions('auth', ['setSessionOAuth']),
    async fetchAuthorize() {
      const query = this.$route.query;
      try {
        const res = await oAuthApi.authorize(query);
        if (res?.status == 200) {
          this.setSessionOAuth(query);
        }
      } catch (_) {
        const getRedirectUri = this.getQuery?.redirectURI;
        if (getRedirectUri)
          window.location.href = `https://${getRedirectUri}?error=authorize`;
      }
    },
    clearQuery() {
      this.$router.replace({ query: {} });
    }
  }
};
</script>
